/**
 * 活动开放时间 时间戳
 * 1622538000000
 * @type {number}
 */

export const ActivityStartTime = 1625130000000
